<template>
  <div class="mint-block">
    <div class="mint-block__tabs mint-block__section">
      <Button
        is-secondary
        class="mint-block__tabs-tab"
        :class="{ '--active': !isMint }"
        @click="isMint = false"
      >Claim</Button>

      <Button
        is-secondary
        class="mint-block__tabs-tab"
        :class="{ '--active': isMint }"
      >Mint</Button>

      <Button
        class="mint-block__tabs-tab"
        @click="onPlayClick"
      >Play</Button>
    </div>

    <img :src="require('@/assets/images/nft.png')" class="mint-block__image mint-block__section" />

    <template v-if="!walletStore.address">
      <Button class="mint-block__button mint-block__section" @click="onConnectClick">Connect Wallet</Button>
    </template>

    <template v-else-if="isMint">
      <Counter v-model="count" class="mint-block__counter mint-block__section" />

      <Button class="mint-block__button mint-block__section" @click="onMintClick">Mint for {{ removeDecimals(price) }} ETH</Button>
    </template>

    <template v-else>
      <div class="mint-block__tabs mint-block__section">
        <Button
          is-secondary
          class="mint-block__tabs-tab"
          :class="{ '--active': claimTokenType === 'fft' }"
          @click="claimTokenType = 'fft'"
        >FFT</Button>

        <Button
          is-secondary
          class="mint-block__tabs-tab"
          :class="{ '--active': claimTokenType === 'nfcheese' }"
          @click="claimTokenType = 'nfcheese'"
        >NFCheese</Button>
      </div>

      <Select :value="claimTokenId" :is-fft="claimTokenType === 'fft'" placeholder="Token ID" class="mint-block__section" />

      <Button class="mint-block__button mint-block__section" @click="onClaimClick">
        Claim for {{ claimTokenType.toUpperCase() }} {{ claimTokenId ? `#${claimTokenId}` : '' }}
      </Button>
    </template>
  </div>
</template>

<script setup>
import Button from '@/ui/Button.vue'
import Counter from '@/ui/Counter.vue'
import Select from '@/ui/Select.vue'

import { ref, watch, onMounted, computed } from 'vue'
import { removeDecimals, mint, getMintPrice, claimFotFft, claimForNfcheese } from '@/logic/mint'
import { connectWallet } from '@/logic/connect'
import { useLayoutStore, useWalletStore, useSelectStore } from '@/store'

const walletStore = useWalletStore()
const layoutStore = useLayoutStore()
const selectStore = useSelectStore()

const isMint = ref(false)
const count = ref(1)
const price = ref(null)
const claimTokenType = ref('fft')
const claimTokenId = computed(() => selectStore.tokenId)

watch(count, updatePrice)
watch(claimTokenType, () => {
  selectStore.tokenId = null
})

onMounted(() => {
  updatePrice()
})

async function updatePrice() {
  price.value = await getMintPrice(count.value)
}

async function onMintClick() {
  layoutStore.startLoading()

  try {
    await mint(count.value)
  } catch (e) {
    layoutStore.stopLoading()
  }

  layoutStore.stopLoading()
}

async function onClaimClick() {
  if (!claimTokenId.value) {
    return alert('Select token ID!')
  }

  layoutStore.startLoading()

  try {
    claimTokenType.value === 'fft'
      ? await claimFotFft(claimTokenId.value)
      : await claimForNfcheese(claimTokenId.value)

    selectStore.tokenId = null
  } catch (e) {
    layoutStore.stopLoading()
  }

  layoutStore.stopLoading()
}

async function onConnectClick() {
  await connectWallet()
}

function onPlayClick() {
  window.open('https://play.deathfi.app', '_blank')
}
</script>

<style lang="sass">
.mint-block
  &__tabs
    display: flex
    gap: 12px

    &-tab
      width: 100%

      &.--active
        opacity: 0.4
        transform: scale(0.9)
        pointer-events: none

  &__image
    width: 100%
    height: auto
    aspect-ratio: 1/1

  &__button
    width: 100%

  &__section
    animation: fadeId 1s ease

    &:not(:last-child)
      margin-bottom: 12px

</style>